// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__LYqXy","title":"Header_title__osunB","left":"Header_left__1RMzR","clinicName":"Header_clinicName__3qSkN"};